import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./FAQs.css";

const faqs = [
  {
    question: "Where is Muktinath Temple located?",
    answer:
      "Muktinath Temple is located in the Mustang district of Nepal at an altitude of around 3,800 meters in the Himalayas. It is one of the sacred pilgrimage sites for both Hindus and Buddhists.",
  },
  {
    question: "How can I reach Muktinath Darshan?",
    answer:
      "You can reach Muktinath via Kathmandu → Pokhara → Jomsom route by flight, road journey, or helicopter services. From Jomsom, pilgrims travel by jeep or trek to the temple.",
  },
  {
    question: "What is the best time to visit Muktinath Temple?",
    answer:
      "The best time for Muktinath Darshan is from March to June and September to November when the weather remains clear and suitable for travel in the Himalayan region.",
  },
  {
    question: "Do Indian citizens need a passport or visa for Nepal?",
    answer:
      "Indian citizens do not require a visa to travel to Nepal. A valid government ID such as Aadhaar Card, Voter ID, or Passport is sufficient for travel.",
  },
  {
    question: "Is Muktinath Yatra difficult?",
    answer:
      "The journey involves high altitude travel, but it is manageable with proper acclimatization. Helicopter and jeep options make the pilgrimage comfortable for senior citizens as well.",
  },
  {
    question: "What is special about Muktinath Temple?",
    answer:
      "Muktinath is believed to grant salvation (Moksha). Devotees take a holy bath under the 108 water spouts and seek blessings of Lord Vishnu at this sacred Himalayan temple.",
  },
  {
    question: "Are helicopter tours available for Muktinath Darshan?",
    answer:
      "Yes, helicopter darshan packages are available from Pokhara or Kathmandu, offering a quick and comfortable same-day pilgrimage experience.",
  },
  {
    question: "What kind of accommodation is available during the Yatra?",
    answer:
      "Pilgrims stay in comfortable hotels in Kathmandu and Pokhara, while basic but clean lodges and guesthouses are available near Muktinath and Jomsom.",
  },
  {
    question: "Is Muktinath Darshan safe for senior citizens?",
    answer:
      "Yes, with proper planning and medical precautions, senior citizens can comfortably complete the yatra, especially using helicopter or jeep-based packages.",
  },
  {
    question: "What should I carry for Muktinath Yatra?",
    answer:
      "Carry warm clothes, comfortable walking shoes, sunglasses, sunscreen, personal medicines, and identity proof. Weather conditions can change quickly in the mountains.",
  },
];

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="andaman-faq-section">
      
      {/* Floating Decor */}
      <div className="floating-decor leaf"></div>

      <div className="andaman-faq-hero">
        <h1>Muktinath Darshan FAQs</h1>
        <p>
          Planning your sacred Muktinath Yatra? Here are answers to the most
          common questions to help you prepare for a smooth and divine journey.
        </p>
      </div>

      <div className="andaman-faq-container">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`andaman-faq-card ${
              activeIndex === index ? "active" : ""
            }`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="andaman-faq-question">
              <h3>{faq.question}</h3>
              <FaChevronDown
                className={`icon ${activeIndex === index ? "rotate" : ""}`}
              />
            </div>

            <div
              className="andaman-faq-answer"
              style={{
                maxHeight: activeIndex === index ? "200px" : "0",
                opacity: activeIndex === index ? "1" : "0",
              }}
            >
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Shape */}
      <div className="andaman-wave"></div>
    </section>
  );
};

export default FAQs;